import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function HeroSection() {
  return <section id="home" className="relative w-full h-screen min-h-[700px] flex items-center justify-center overflow-hidden" data-id="element-76">
      <div className="absolute inset-0" data-id="element-77">
        <img src="https://cdn.magicpatterns.com/uploads/15YH9BbQT1QsJ7mjg27SrU/WhatsApp_Image_2026-04-03_at_12.38.51_AM.jpg" alt="Kia PV5 campervan with pop-top roof in workshop, front three-quarter view" className="w-full h-full object-cover" data-id="element-78" />
        <div className="absolute inset-0 bg-gradient-to-b from-dark-900/80 via-dark-900/60 to-dark-900/90" data-id="element-79" />
        <div className="absolute inset-0 bg-gradient-to-r from-dark-900/50 to-transparent" data-id="element-80" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center" data-id="element-81">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} data-id="element-82">
          <p className="text-gold text-sm font-semibold tracking-[0.3em] uppercase mb-6 font-body" data-id="element-83">
            Buckinghamshire, UK
          </p>
          <h1 className="font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold leading-tight mb-8 tracking-tight" data-id="element-84">
            The UK's Premier PV5
            <br data-id="element-85" />
            <span className="text-gold" data-id="element-86">Campervan Conversion</span>
            <br data-id="element-87" />
            Specialists
          </h1>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.3,
        ease: 'easeOut'
      }} className="text-white/60 text-base sm:text-lg max-w-2xl mx-auto mb-10 leading-relaxed font-body" data-id="element-88">
          Buckinghamshire-based experts transforming Kia's remarkable PV5 into
          your perfect adventure vehicle—available through Europe's largest Kia
          showroom.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.6,
        ease: 'easeOut'
      }} data-id="element-89">
          <a href="#services" className="inline-block px-10 py-4 bg-gold text-dark-900 font-semibold text-sm tracking-widest uppercase rounded hover:bg-gold-hover transition-all duration-300 hover:shadow-lg hover:shadow-gold/20" data-id="element-90">
            Explore Our Conversions
          </a>
        </motion.div>
      </div>

      <motion.a href="#about" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.2,
      duration: 1
    }} className="absolute bottom-10 left-1/2 -translate-x-1/2 text-white/40 hover:text-gold transition-colors" aria-label="Scroll down" data-id="element-91">
        <motion.div animate={{
        y: [0, 8, 0]
      }} transition={{
        repeat: Infinity,
        duration: 2,
        ease: 'easeInOut'
      }} data-id="element-92">
          <ChevronDownIcon size={28} data-id="element-93" />
        </motion.div>
      </motion.a>
    </section>;
}